import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
var CheckboxGroupContext = React.createContext({});
export var CheckboxGroupProvider = function (_a) {
    var value = _a.value, onChange = _a.onChange, children = _a.children;
    return (_jsx(CheckboxGroupContext.Provider, { value: { value: value, onChange: onChange }, children: children }));
};
export var useCheckboxGroupContext = function () {
    var context = React.useContext(CheckboxGroupContext);
    if (!context) {
        throw new Error('CheckboxGroup compound components cannot be rendered outside the CheckboxGroup component');
    }
    return context;
};
